var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarStorageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21916",
    "data-name": "\\uADF8\\uB8F9 21916",
    transform: "translate(-728 -1215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28339",
    "data-name": "\\uC0AC\\uAC01\\uD615 28339",
    width: 40,
    height: 40,
    transform: "translate(728 1215)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21915",
    "data-name": "\\uADF8\\uB8F9 21915",
    transform: "translate(4.476 -0.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "database",
    d: "M32.951,20.7h0v-6.57h0V7.613c0-3.6-4.8-6.413-10.95-6.413S11,4.068,11,7.613v6.465h0V20.7h0v6.2c0,3.546,4.9,6.413,10.95,6.413S32.9,30.451,32.9,26.905V20.857C32.9,20.8,32.951,20.753,32.951,20.7ZM13.242,17.937a15.218,15.218,0,0,0,8.707,2.4,14.982,14.982,0,0,0,8.707-2.4,1.406,1.406,0,0,0,.417-.365V20.8c-.156,2.086-3.806,4.276-9.125,4.276-5.37,0-9.02-2.19-9.125-4.328V17.52A1.067,1.067,0,0,0,13.242,17.937Zm-.417-3.7V11.211c1.929,1.721,5.266,2.816,9.125,2.816s7.2-1.095,9.125-2.816v2.972a3.159,3.159,0,0,1-1.512,2.242,13.057,13.057,0,0,1-7.613,2.033,13.579,13.579,0,0,1-7.613-2.033A2.963,2.963,0,0,1,12.825,14.235ZM21.95,3.077c4.953,0,9.125,2.086,9.125,4.588S26.9,12.254,21.95,12.254s-9.125-2.086-9.125-4.588S17,3.077,21.95,3.077Zm0,28.417c-5.37,0-9.125-2.4-9.125-4.588V24.246c1.929,1.669,5.266,2.763,9.125,2.763s7.2-1.095,9.125-2.763v2.659C31.074,29.043,27.32,31.494,21.95,31.494Z",
    transform: "translate(718.049 1218.793)",
    fill: "#343a40"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1223",
    "data-name": "\\uD0C0\\uC6D0 1223",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(752 1218.33)",
    fill: "#ff6a13"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarStorageIcon);
export default __webpack_public_path__ + "static/media/CarStorageIcon.d85614dec39e4520a7359d5a1243f066.svg";
export { ForwardRef as ReactComponent };